import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSocket } from './SocketContext';

const SocketStatContext = createContext();

export const useSocketStats = () => useContext(SocketStatContext);

export const SocketStatProvider = ({ children }) => {
  const { socket } = useSocket();
  const [counterStats, setCounterStats] = useState([]);
  const [agentStats, setAgentStats] = useState([]);

  useEffect(() => {
    if (!socket) return;

    socket.emit('requestLiveCounterStats');
    socket.emit('requestLiveAgentStats');

    socket.on('liveCounterStatus', (data) => setCounterStats(data));
    socket.on('liveAgentStats', (data) => setAgentStats(data));

    return () => {
      socket.off('liveCounterStatus');
      socket.off('liveAgentStats');
    };
  }, [socket]);

  return (
    <SocketStatContext.Provider value={{ counterStats, agentStats }}>
      {children}
    </SocketStatContext.Provider>
  );
};
